<template>
  <div :class="classList">
    <!-- waiting for the Template list to load -->
    <VLoadingSpinner
      size="large"
      v-if="loading"
    />

    <div>
      <VMessage
        type="info"
        subtype="outlined"
        :fullwidth="true"
        v-if="!list.length">
        <template v-slot:icon>
          <InfoCircleIcon />
        </template>
        <template v-slot:text>
          {{ $t('templates.noTemplates') }}
        </template>
      </VMessage>

      <VGrid>
        <div slot="gridItem" type="3" v-for="(item, index) in list" :key="index">
          <div class="document-list__selection-item">
            <VLoadingSpinner v-if="loadingItems[item.fingerprint]" />
            <VCard
              :title="item.title"
              :date="item.created_at"
              :imageSrc="item && item.images ? item.images[0] : null"
              data-ec="templates_envelopes_document_list"
              data-et="select_document_link"
              @action="selectItem(item)"
              @removeAction="removeItem(item)"
              :selected="itemSelected(item)"
              :data-fingerprint="item.fingerprint"
              :ratio="1.4"
              :key="item.fingerprint"
            />
          </div>
        </div>
      </VGrid>
    </div>
  </div>
</template>

<script>
import VLoadingSpinner from '@/components/deprecated/atoms/LoadingSpinner.vue';
import VMessage from '@/components/deprecated/atoms/Message.vue';
import VCard from '@/components/deprecated/molecules/Card.vue';
import VGrid from '@/components/deprecated/organisms/Grid.vue';
import { InfoCircleIcon } from '@/components/icons/fontIcons';

export default {
  name: 'VDocumentList',
  props: {
    loading: {
      type: Boolean,
      required: true,
    },
    list: {
      type: Array,
      required: true,
    },
    loadingItems: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    value: {
      type: Array,
    },
  },
  components: {
    VLoadingSpinner,
    VCard,
    VMessage,
    VGrid,
    InfoCircleIcon,
  },
  computed: {
    classList() {
      return {
        'document-list': true,
        'document-list--collapsed': this.collapsed,
      };
    },
    selectedFingerprints() {
      return this.value.map(doc => doc.fingerprint);
    },
  },
  methods: {
    itemSelected(document) {
      return this.selectedFingerprints.includes(document.fingerprint);
    },
    selectItem(document) {
      if (!this.itemSelected(document)) {
        this.value.push(document);
        this.$emit('input', this.value);
        this.$emit('add', document);
      }
    },
    removeItem(document) {
      const index = this.value.findIndex(item => document.fingerprint === item.fingerprint);

      if (index > -1) {
        this.value.splice(index, 1);
        this.$emit('input', this.value);
        this.$emit('remove', document);
      }
    },
    documentProcessed() {
      this.$store.commit('envelopes/SET_DOCUMENT_PROCESSED', { processed: true });
    },
  },
};
</script>

<style scoped>
.document-list {
  background: #fff;
  border: 1px solid var(--color-border);
  height: 350px;
  overflow: auto;
  padding: var(--spacing-base);
  position: relative;
}

.document-list:after {
  content: '';
  display: block;
  clear: both;
}

.document-list .o-grid {
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr)) !important;
}

.document-list .o-grid__item {
  grid-column: auto;
}

.document-list .o-search {
  margin-bottom: var(--spacing-base);
}

.document-list__selection-item {
  position: relative;
  height: 100%;
}

.document-list__item {
  position: relative;
  border: 3px solid transparent;
  border-radius: 6px;
  cursor: pointer;
}

.document-list__item:hover {
  border-color: var(--color-border);
}

.document-list__item__remove {
  position: absolute;
  background: var(--color-error);
  border: 1px solid var(--color-error-dark);
  color: #fff;
  right: var(--spacing-xs);
  top: var(--spacing-xs);
  line-height: 0;
  height: 22px;
  width: 22px;
  border-radius: 30px;
}

.document-list__item__remove svg {
  height: 12px;
  width: 12px;
  pointer-events: none;
  position: absolute;
  transform: translate3d(-50%, -50%, 0);
  top: 50%;
  left: 50%;
}

.document-list__item__pages {
  position: absolute;
  top: var(--spacing-xs);
  right: var(--spacing-xs);
  padding: var(--spacing-xs) var(--spacing-small);
  font-size: 11px;
  background: #222;
  color: #fff;
  font-weight: bold;
  border-radius: 30px;
}

.document-list__item--selected {
  border-color: var(--signable-primary-1);
  position: relative;
  border-radius: 5px;
}

.document-list__item--selected:hover {
  border-color: var(--signable-primary-1);
}

.document-list__item__image {
  width: 100%;
  height: auto;
  display: block;
  text-align: center;
  height: 100%;
  border-radius: 2px;
  pointer-events: none;
}

.document-list__item__details {
  text-align: center;
  background: #222;
  padding: var(--spacing-xs);
  color: #fff;
  font-size: 14px;
  font-weight: bold;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  pointer-events: none;
  color: #fff;
  border-bottom-left-radius: 2px;
  border-bottom-right-radius: 2px;
}

.document-list__item__details__title {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: var(--spacing-xs);
}

.document-list__item__details__created {
  font-size: 12px;
}

.document-list__item__details__created svg {
  margin-right: var(--spacing-xs);
}
</style>
